module.exports = __webpack_public_path__ + "img/2-why-collaboration.0762a8e7.png";